import React, { useState, useEffect, useRef } from 'react';
import authAxios from "../../services/Token"
import { apiImage } from "../../services/Api";
import { 
    Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input,
    Table, Spinner, Card, CardHeader, CardBody, Row, Col, Badge, Alert
} from "reactstrap"

const DocumentFolderContent = ({ folder, onUpdate, userId }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [newSubFolderName, setNewSubFolderName] = useState('');
    const [uploading, setUploading] = useState(false);
    const [creatingFolder, setCreatingFolder] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [documentForm, setDocumentForm] = useState({
        name: '',
        request_type: 'creacion',
        description: '',
        observacion_solicitud: '',
        version: '1.0',
        creation_date: new Date().toISOString().split('T')[0],
        file: null,
        tipo_documento: '',
        area_solicitante: '',
        folder_id: '',
        pregunta_1: false,
        pregunta_2: false,
        pregunta_3: false,
        pregunta_4: false
    });
    const [statusModal, setStatusModal] = useState({ 
        open: false, 
        document: null, 
        action: '',
        acta_number: '',
        acta_version: '',
        acta_fecha_apro: '',
        observation: '',
        acta_codigo: ''
    });
    const [viewerModal, setViewerModal] = useState({ open: false, document: null });
    const [detailModal, setDetailModal] = useState({ open: false, document: null });
    const [areasEmpresa, setAreasEmpresa] = useState([]);
    const [tipoDocumento, setTipoDocumento] = useState([]);
    
    // Estados para filtros
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('todos');
    const [filteredDocuments, setFilteredDocuments] = useState([]);
    
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        loadAreasEmpresa();
        loadTipoDocumento();
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (folder?.documents) {
            applyFilters();
        }
    }, [folder?.documents, searchTerm, statusFilter]);

    // Cargar áreas de la empresa
    const loadAreasEmpresa = async () => {
        try {
            const response = await authAxios.get('documents/all');
            if (response.data && response.data.areas_empresa) {
                setAreasEmpresa(response.data.areas_empresa);
            }
        } catch (error) {
            console.error('Error loading areas:', error);
        }
    };
    const loadTipoDocumento = async () => {
        try {
            const response = await authAxios.get('tipodocumento/all');
            if (response.data && response.data.tipos) {
                setTipoDocumento(response.data.tipos);
            }
        } catch (error) {
            console.error('Error loading areas:', error);
        }
    };

    const applyFilters = () => {
        if (!folder?.documents) return;

        let filtered = [...folder.documents];

        if (searchTerm.trim() !== '') {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(doc => 
                doc.name.toLowerCase().includes(term) ||
                (doc.description && doc.description.toLowerCase().includes(term)) ||
                (doc.area_solicitante && doc.area_solicitante.toLowerCase().includes(term)) ||
                (doc.tipo_documento && doc.tipo_documento.toLowerCase().includes(term))
            );
        }

        if (statusFilter !== 'todos') {
            filtered = filtered.filter(doc => doc.status === statusFilter);
        }

        setFilteredDocuments(filtered);
    };

    const safeSetState = (setter, value) => {
        if (isMounted.current) {
            setter(value);
        }
    };

    // Función para renderizar opciones de áreas
    const renderAreaOptions = () => {
        if (!Array.isArray(areasEmpresa) || areasEmpresa.length === 0) {
            return <option value="">No hay áreas disponibles</option>;
        }

        return (
            <>
                <option value="">Selecciona un área</option>
                {areasEmpresa.map(area => (
                    <option key={area.id} value={area.nombre}>
                        {area.nombre}
                    </option>
                ))}
            </>
        );
    };
    const renderTipoOptions = () => {
        if (!Array.isArray(tipoDocumento) || tipoDocumento.length === 0) {
            return <option value="">No hay Tipo de documento</option>;
        }

        return (
            <>
                <option value="">Selecciona Tipo Documento</option>
                {tipoDocumento.map(area => (
                    <option key={area.id} value={area.nombre}>
                        {area.nombre}
                    </option>
                ))}
            </>
        );
    };

    const handleDocumentSubmit = async (e) => {
        e.preventDefault();
        if (!documentForm.file) {
            alert('Por favor selecciona un archivo');
            return;
        }

        if (!userId) {
            alert('No se encontró el ID de usuario');
            return;
        }

        // Validar campos requeridos
        if (!documentForm.tipo_documento) {
            alert('Por favor selecciona el tipo de documento');
            return;
        }

        if (!documentForm.area_solicitante) {
            alert('Por favor selecciona el área solicitante');
            return;
        }

        safeSetState(setUploading, true);
        const formData = new FormData();
        
        // Agregar todos los campos del formulario
        Object.keys(documentForm).forEach(key => {
            if (key === 'file') {
                formData.append(key, documentForm[key]);
            } else if (key === 'pregunta_1' || key === 'pregunta_2' || key === 'pregunta_3' || key === 'pregunta_4') {
                formData.append(key, documentForm[key] ? 1 : 0);
            } else {
                formData.append(key, documentForm[key]);
            }
        });

        // Asegurar que el folder_id sea el correcto
        formData.append('folder_id', folder.id);

        try {
            await authAxios.post('documents', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            if (isMounted.current) {
                setModalOpen(false);
                setDocumentForm({
                    name: '',
                    request_type: 'creacion',
                    description: '',
                    observacion_solicitud: '',
                    version: '1.0',
                    creation_date: new Date().toISOString().split('T')[0],
                    file: null,
                    tipo_documento: '',
                    area_solicitante: '',
                    folder_id: '',
                    pregunta_1: false,
                    pregunta_2: false,
                    pregunta_3: false,
                    pregunta_4: false
                });
                onUpdate();
                alert('Documento creado correctamente');
            }
        } catch (error) {
            console.error('Error creating document:', error);
            if (isMounted.current) {
                alert('Error al crear el documento: ' + (error.response?.data?.message || error.message));
            }
        } finally {
            safeSetState(setUploading, false);
        }
    };

    const createSubFolder = async () => {
        if (!newSubFolderName.trim()) {
            alert('Por favor ingresa un nombre para la subcarpeta');
            return;
        }

        if (!userId) {
            alert('No se encontró el ID de usuario');
            return;
        }

        if (folder.level >= 7) {
            alert('No se pueden crear más de 7 niveles de carpetas');
            return;
        }

        safeSetState(setCreatingFolder, true);
        try {
            await authAxios.post('folders', {
                name: newSubFolderName,
                parent_id: folder.id
            });
            
            if (isMounted.current) {
                setNewSubFolderName('');
                onUpdate();
                alert('Subcarpeta creada correctamente');
            }
        } catch (error) {
            console.error('Error creating subfolder:', error);
            if (isMounted.current) {
                alert('Error al crear la subcarpeta: ' + (error.response?.data?.message || error.message));
            }
        } finally {
            safeSetState(setCreatingFolder, false);
        }
    };

    // Función actualizada para aprobar/rechazar documentos
    const updateDocumentStatus = async (documentId, status, acta_number = '', observation = '', acta_version = '', acta_fecha = '', codigo = '') => {
        try {
            await authAxios.put(`documents/${documentId}/status`, {
                status,
                acta_number: status === 'aprobado' ? acta_number : null,
                rejection_observation: observation,
                acta_version: status === 'aprobado' ? acta_version : null,
                acta_fecha: status === 'aprobado' ? acta_fecha : null,
                codigo: status === 'aprobado' ? codigo : null
            });
            
            onUpdate();
            setStatusModal({ 
                open: false, 
                document: null, 
                action: '',
                acta_number: '',
                observation: '',
                acta_version: '',
                acta_fecha: '',
                acta_codigo: ''
            });
            alert('Estado del documento actualizado correctamente');
        } catch (error) {
            console.error('Error updating document status:', error);
            alert('Error al actualizar el estado: ' + (error.response?.data?.message || error.message));
        }
    };

    // Función para manejar el envío del formulario de aprobación/rechazo
    const handleStatusSubmit = () => {
        const { document, action, acta_number, acta_version, acta_fecha_apro, observation, acta_codigo } = statusModal;

        if (action === 'aprobado') {
            if (!acta_number.trim()) {
                alert('Por favor ingresa el número de acta');
                return;
            }
            if (!acta_codigo.trim()) {
                alert('Por favor ingresa el código del documento');
                return;
            }
            if (!acta_version.trim()) {
                alert('Por favor ingresa el número de versión');
                return;
            }
            if (!acta_fecha_apro) {
                alert('Por favor selecciona la fecha de vigencia');
                return;
            }
            updateDocumentStatus(document.id, action, acta_number, '', acta_version, acta_fecha_apro, acta_codigo);
        } else if (action === 'rechazado') {
            if (!observation.trim()) {
                alert('Por favor ingresa una observación para el rechazo');
                return;
            }
            updateDocumentStatus(document.id, action, '', observation, '', '', '');
        }
    };

    // Función para abrir modal de aprobar/rechazar
    const openStatusModal = (document, action) => {
        setStatusModal({ 
            open: true, 
            document, 
            action,
            acta_number: '',
            observation: '',
            acta_version: '',
            acta_fecha_apro: '',
            acta_codigo: ''
        });
    };

    const deleteDocument = async (documentId) => {
        if (!window.confirm('¿Estás seguro de que quieres eliminar este documento?')) {
            return;
        }
        
        try {
            await authAxios.delete(`documents/${documentId}`);
            onUpdate();
            alert('Documento eliminado correctamente');
        } catch (error) {
            console.error('Error deleting document:', error);
            alert('Error al eliminar el documento: ' + (error.response?.data?.message || error.message));
        }
    };

    const deleteSubFolder = async (subFolderId) => {
        if (!window.confirm('¿Estás seguro de que quieres eliminar esta carpeta y todo su contenido?')) {
            return;
        }
        
        try {
            const response = await authAxios.delete(`folders/${subFolderId}`);
            onUpdate();
            
            alert(response.data.message);
        } catch (error) {
            console.error('Error deleting folder:', error);
            alert('Error al eliminar la carpeta: ' + (error.response?.data?.message || error.message));
        }
    };
     const deleteFolder = async (subFolderId) => {
        if (!window.confirm('¿Estás seguro de que quieres eliminar esta carpeta?')) {
            return;
        }
        
        try {
            const response = await authAxios.delete(`folders/${subFolderId}`);
            
            
            alert(response.data.message);
            if(response.data.status==1){
               window.location.reload();
            }
        } catch (error) {
            console.error('Error deleting folder:', error);
            alert('Error al eliminar la carpeta: ' + (error.response?.data?.message || error.message));
        }
    };

    const getDocumentUrl = (document) => {
        if (!document.file_path) return null;
        return `${apiImage}${document.file_path}`;
    };

    const downloadDocument = async (doc) => {
        try {
            const fileUrl = getDocumentUrl(doc);
            
            if (!fileUrl) {
                alert('No se encontró la ruta del archivo');
                return;
            }

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', doc.name || 'documento');
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
        } catch (error) {
            console.error('Error downloading document:', error);
            alert('Error al descargar el documento');
        }
    };

    const viewDocument = (document) => {
        const fileUrl = getDocumentUrl(document);
        if (fileUrl) {
            setViewerModal({ open: true, document: { ...document, file_url: fileUrl } });
        } else {
            alert('No se puede visualizar el documento: Ruta no disponible');
        }
    };

    const viewDocumentDetails = (document) => {
        setDetailModal({ open: true, document });
    };

    const canDownloadDocument = (document) => {
        const isAdmin = localStorage.getItem("idusuario") === "3" || localStorage.getItem("idusuario") === "1";
        return document.status === 'aprobado' || isAdmin;
    };

    const canViewDocument = (document) => {
        const isAdmin = localStorage.getItem("idusuario") === "3" || localStorage.getItem("idusuario") === "1";
        return isAdmin || document.status === 'aprobado';
    };

    const isViewableFileType = (fileType) => {
        if (!fileType) return false;
        const viewableTypes = ['pdf', 'image', 'txt'];
        return viewableTypes.some(type => fileType.includes(type));
    };

    const getFileIcon = (fileType) => {
        if (!fileType) return '📎';
        
        const type = fileType.toLowerCase();
        
        if (type.includes('pdf')) return '📕';
        if (type.includes('image')) return '🖼️';
        if (type.includes('xlsx') || type.includes('excel') || type.includes('spreadsheet')) return '📊';
        if (type.includes('word') || type.includes('document') || type.includes('doc')) return '📃';
        if (type.includes('text') || type.includes('txt')) return '📄';
        if (type.includes('powerpoint') || type.includes('presentation')) return '📑';
        if (type.includes('zip') || type.includes('rar') || type.includes('compressed')) return '🗜️';
        if (type.includes('video')) return '🎬';
        if (type.includes('audio')) return '🎵';
        if (type.includes('csv')) return '📈';
        return '📎';
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            sin_revisar: { color: 'secondary', text: 'Sin Revisar' },
            en_proceso: { color: 'warning', text: 'En Proceso' },
            aprobado: { color: 'success', text: 'Aprobado' },
            rechazado: { color: 'danger', text: 'Rechazado' },
             reemplazado: { color: 'danger', text: 'Reemplazado' }
        };
        const config = statusConfig[status] || statusConfig.sin_revisar;
        return <Badge color={config.color}>{config.text}</Badge>;
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const getPreguntaText = (preguntaNum) => {
        const preguntas = {
            1: "Se crea o da de baja un documento del sistema de calidad",
            2: "Se crea, da de baja o se cambia el título a un formato del sistema de calidad",
            3: "Se cambian, incluyen o excluyen los títulos de los cargos en el organigrama y demás documentos del sistema de calidad",
            4: "La creación, actualización o dada de baja afecta la documentación del sistema de calidad"
        };
        return preguntas[preguntaNum] || '';
    };

    const getPreguntaBadge = (value) => {
        return value ? 
            <Badge color="success">Sí</Badge> : 
            <Badge color="secondary">No</Badge>;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'No especificada';
        
        try {
            const datePart = dateString.split('T')[0];
            const [year, month, day] = datePart.split('-');
            const date = new Date(year, month - 1, day);
            
            return date.toLocaleDateString('es-CO', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (error) {
            console.error('Error formateando fecha:', error);
            return dateString;
        }
    };

    const isAdmin = localStorage.getItem("idusuario") === "3" || localStorage.getItem("idusuario") === "1";

    const clearFilters = () => {
        setSearchTerm('');
        setStatusFilter('todos');
    };

    const hasActiveFilters = searchTerm || statusFilter !== 'todos';

    if (!isMounted.current) {
        return null;
    }

    return (
        <div>
            {/* Header de la carpeta */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="mb-1">📁 {folder.name}</h4>
                    <small className="text-muted">
                        Nivel {folder.level} • {filteredDocuments.length} de {folder.documents?.length || 0} documentos
                        {hasActiveFilters && ' (filtrados)'}
                    </small>
                </div>
       
                <div>
                    <button 
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => deleteFolder(folder.id)}
                                                    title="Eliminar carpeta"
                                                >
                                                    🗑️ Eliminar carpeta raiz
                                                </button>  
                    <Button color="success" onClick={() => setModalOpen(true)}>
                        <i className="fas fa-plus me-2"></i>
                        Nuevo Documento
                    </Button>
                </div>
            </div>

            {/* Panel de Filtros */}
            <Card className="mb-4">
                <CardHeader className="bg-light text-dark">
                    <h5 className="mb-0">🔍 Filtros de Documentos {newSubFolderName}</h5>
                </CardHeader>
                <CardBody>
                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <Label>Buscar por nombre</Label>
                                <Input
                                    type="text"
                                    placeholder="Nombre, descripción, área o tipo de documento..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label>Filtrar por estado</Label>
                                <Input
                                    type="select"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="todos">Todos los estados</option>
                                    <option value="sin_revisar">Sin Revisar</option>
                                    <option value="en_proceso">En Proceso</option>
                                    <option value="aprobado">Aprobado</option>
                                    <option value="rechazado">Rechazado</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={2} className="d-flex align-items-end">
                            {hasActiveFilters && (
                                <Button 
                                    color="outline-secondary" 
                                    onClick={clearFilters}
                                    className="w-100"
                                >
                                    <i className="fas fa-times me-2"></i>
                                    Limpiar
                                </Button>
                            )}
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Panel de acciones */}
            <div className="row mb-4">
                <div className="col-md-6">
                    <div className="card h-100">
                        <div className="card-body">
                            <h5 className="card-title">📂 Crear Subcarpeta </h5>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nombre de la subcarpeta"
                                    value={newSubFolderName}
                                    onChange={(e) => setNewSubFolderName(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && createSubFolder()}
                                />
                                <button 
                                    className="btn btn-success"
                                    onClick={createSubFolder}
                                    disabled={!newSubFolderName.trim() || !userId || creatingFolder || folder.level >= 7}
                                >
                                    {creatingFolder ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Creando...
                                        </>
                                    ) : (
                                        'Crear'
                                    )}
                                </button>
                            </div>
                            {folder.level >= 7 && (
                                <small className="text-danger">
                                    Máximo de 7 niveles alcanzado
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                
                <div className="col-md-6">
                    <div className="card h-100">
                        <div className="card-body">
                            <h5 className="card-title">📊 Resumen</h5>
                            <div className="row text-center">
                                <div className="col-6">
                                    <div className="border rounded p-2">
                                        <div className="fs-4">{folder.children?.length || 0}</div>
                                        <small className="text-muted">Subcarpetas</small>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="border rounded p-2">
                                        <div className="fs-4">{filteredDocuments.length}</div>
                                        <small className="text-muted">Documentos</small>
                                        {hasActiveFilters && (
                                            <small className="text-warning d-block">
                                                (filtrados)
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Subcarpetas */}
            {folder.children && folder.children.length > 0 && (
                <div className="card mb-4">
                    <div className="card-header bg-primary text-white">
                        <h5 className="mb-0">📂 Subcarpetas ({folder.children.length})</h5>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            {folder.children.map(child => (
                                <div key={child.id} className="col-md-6 mb-3">
                                    <div className="card border">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div className="flex-grow-1">
                                                    <h6 className="card-title mb-1">
                                                        📁 {child.name}
                                                    </h6>
                                                    <small className="text-muted d-block">
                                                        Nivel {child.level}
                                                    </small>
                                                    <small className="text-muted">
                                                        {child.documents?.length || 0} documentos
                                                    </small>
                                                </div>
                                                <button 
                                                    className="btn btn-sm btn-outline-danger ms-2"
                                                    onClick={() => deleteSubFolder(child.id)}
                                                    title="Eliminar carpeta"
                                                >
                                                    🗑️
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Documentos */}
            <div className="card">
                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                        📄 Documentos ({filteredDocuments.length} de {folder.documents ? folder.documents.length : 0})
                        {hasActiveFilters && ' (filtrados)'}
                    </h5>
                    {hasActiveFilters && (
                        <Button color="light" size="sm" onClick={clearFilters}>
                            <i className="fas fa-times me-1"></i>
                            Limpiar Filtros
                        </Button>
                    )}
                </div>
                <div className="card-body">
                    {filteredDocuments.length > 0 ? (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th width="50px">Tipo</th>
                                        <th>Nombre del Documento</th>
                                        <th width="100px">Tipo Doc.</th>
                                        <th width="120px">Área</th>
                                        <th width="100px">Solicitud</th>
                                        <th width="120px">Estado</th>
                                        <th width="120px">Fecha</th>
                                        <th width="250px" className="text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredDocuments.map(doc => (
                                        <tr key={doc.id}>
                                            <td className="text-center fs-5">
                                                {getFileIcon(doc.file_type)}
                                            </td>
                                            <td>
                                                <div>
                                                    <strong className="d-block">{doc.name}</strong>
                                                    <small className="text-muted">
                                                        {doc.description && doc.description.substring(0, 50)}...
                                                    </small>
                                                    {doc.acta_number && (
                                                        <small className="text-success d-block">
                                                            <strong>Acta: {doc.acta_number}</strong>
                                                        </small>
                                                    )}
                                                    {doc.codigo && (
                                                        <small className="text-info d-block">
                                                            <strong>Código: {doc.codigo}</strong>
                                                        </small>
                                                    )}
                                                    {doc.version && (
                                                        <small className="text-primary d-block">
                                                            <strong>v{doc.version}</strong>
                                                        </small>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <small className="text-muted">
                                                    {doc.tipo_documento}
                                                </small>
                                            </td>
                                            <td>
                                                <small className="text-muted">
                                                    {doc.area_solicitante}
                                                </small>
                                            </td>
                                            <td>
                                                <span className="badge bg-info text-capitalize">
                                                    {doc.request_type}
                                                </span>
                                            </td>
                                            <td>
                                                {getStatusBadge(doc.status)}
                                            </td>
                                            <td>
                                                <small className="text-muted">
                                                    {formatDate(doc.creation_date)}
                                                </small>
                                            </td>
                                            <td className="text-center">
                                                <div className="btn-group btn-group-sm" role="group">
                                                    {/* Botón para ver detalles */}
                                                    <button 
                                                        className="btn btn-outline-info"
                                                        onClick={() => viewDocumentDetails(doc)}
                                                        title="Ver detalles"
                                                    >
                                                        📋
                                                    </button>
                                                    
                                                    {/* Botón para ver documento */}
                                                    {canViewDocument(doc) && isViewableFileType(doc.file_type) && (
                                                        <button 
                                                            className="btn btn-outline-primary"
                                                            onClick={() => viewDocument(doc)}
                                                            title="Ver documento"
                                                        >
                                                            👁️
                                                        </button>
                                                    )}
                                                    
                                                    {/* Botón para descargar documento */}
                                                    {canDownloadDocument(doc) && (
                                                        <button 
                                                            className="btn btn-outline-success"
                                                            onClick={() => downloadDocument(doc)}
                                                            title="Descargar documento"
                                                        >
                                                            ⬇️
                                                        </button>
                                                    )}

                                                    {/* Botones de administrador */}
                                                    {isAdmin && doc.status === 'sin_revisar' && (
                                                        <>
                                                            <button 
                                                                className="btn btn-outline-success"
                                                                onClick={() => openStatusModal(doc, 'aprobado')}
                                                                title="Aprobar"
                                                            >
                                                                ✓
                                                            </button>
                                                            <button 
                                                                className="btn btn-outline-danger"
                                                                onClick={() => openStatusModal(doc, 'rechazado')}
                                                                title="Rechazar"
                                                            >
                                                                ✗
                                                            </button>
                                                        </>
                                                    )}
                                                    
                                                    {/* Botón eliminar (solo admin) */}
                                                    {isAdmin && (
                                                        <button 
                                                            className="btn btn-outline-danger"
                                                            onClick={() => deleteDocument(doc.id)}
                                                            title="Eliminar"
                                                        >
                                                            🗑️
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <div className="fs-1 text-muted mb-3">📄</div>
                            <h5 className="text-muted">
                                {hasActiveFilters ? 'No hay documentos que coincidan con los filtros' : 'No hay documentos en esta carpeta'}
                            </h5>
                            <p className="text-muted">
                                {hasActiveFilters 
                                    ? 'Intenta con otros criterios de búsqueda' 
                                    : 'Crea tu primer documento usando el botón "Nuevo Documento"'
                                }
                            </p>
                            {hasActiveFilters && (
                                <Button color="primary" onClick={clearFilters}>
                                    Limpiar Filtros
                                </Button>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Modal para crear documento */}
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
                <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
                    📄 Crear Nuevo Documento
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleDocumentSubmit}>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Nombre del Documento *</Label>
                                    <Input
                                        type="text"
                                        value={documentForm.name}
                                        onChange={(e) => setDocumentForm({...documentForm, name: e.target.value})}
                                        placeholder="Ingresa el nombre del documento"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Tipo de Documento *</Label>
                                    <Input
                                        type="select"
                                        value={documentForm.tipo_documento}
                                        onChange={(e) => setDocumentForm({...documentForm, tipo_documento: e.target.value})}
                                        required
                                    >
                                          {renderTipoOptions()}
                                   
                                     
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Área Solicitante *</Label>
                                    <Input
                                        type="select"
                                        value={documentForm.area_solicitante}
                                        onChange={(e) => setDocumentForm({...documentForm, area_solicitante: e.target.value})}
                                        required
                                    >
                                        {renderAreaOptions()}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Tipo de Solicitud *</Label>
                                    <Input
                                        type="select"
                                        value={documentForm.request_type}
                                        onChange={(e) => setDocumentForm({...documentForm, request_type: e.target.value})}
                                        required
                                    >
                                        <option value="creacion">Creación</option>
                                        <option value="actualizacion">Actualización</option>
                                        <option value="eliminar">Eliminar</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Versión *</Label>
                                    <Input
                                        type="text"
                                        value={documentForm.version}
                                        onChange={(e) => setDocumentForm({...documentForm, version: e.target.value})}
                                        placeholder="Ej: 1.0, 2.1, etc."
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Fecha de Solicitud *</Label>
                                    <Input
                                        type="date"
                                        value={documentForm.creation_date}
                                        onChange={(e) => setDocumentForm({...documentForm, creation_date: e.target.value})}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Label>Descripción del documento *</Label>
                            <Input
                                type="textarea"
                                rows="3"
                                value={documentForm.description}
                                onChange={(e) => setDocumentForm({...documentForm, description: e.target.value})}
                                placeholder="Describe el contenido del documento"
                                required
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Descripción de la solicitud *</Label>
                            <Input
                                type="textarea"
                                rows="3"
                                value={documentForm.observacion_solicitud}
                                onChange={(e) => setDocumentForm({...documentForm, observacion_solicitud: e.target.value})}
                                placeholder="Describe el propósito de la solicitud"
                                required
                            />
                        </FormGroup>

                        {/* Preguntas de repercusión */}
                        <Card className="mb-3">
                            <CardHeader className="bg-light text-dark">
                                <h6 className="mb-0">📋 Repercusión del Cambio en Otros Documentos</h6>
                            </CardHeader>
                            <CardBody>
                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={documentForm.pregunta_1}
                                        onChange={(e) => setDocumentForm({...documentForm, pregunta_1: e.target.checked})}
                                    />
                                    <Label check>
                                        Se crea o da de baja un documento del sistema de calidad
                                    </Label>
                                </FormGroup>

                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={documentForm.pregunta_2}
                                        onChange={(e) => setDocumentForm({...documentForm, pregunta_2: e.target.checked})}
                                    />
                                    <Label check>
                                        Se crea, da de baja o se cambia el título a un formato del sistema de calidad
                                    </Label>
                                </FormGroup>

                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={documentForm.pregunta_3}
                                        onChange={(e) => setDocumentForm({...documentForm, pregunta_3: e.target.checked})}
                                    />
                                    <Label check>
                                        Se cambian, incluyen o excluyen los títulos de los cargos en el organigrama y demás documentos del sistema de calidad
                                    </Label>
                                </FormGroup>

                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={documentForm.pregunta_4}
                                        onChange={(e) => setDocumentForm({...documentForm, pregunta_4: e.target.checked})}
                                    />
                                    <Label check>
                                        La creación, actualización o dada de baja afecta la documentación del sistema de calidad
                                    </Label>
                                </FormGroup>
                            </CardBody>
                        </Card>

                        <FormGroup className="mt-3">
                            <Label>Archivo *</Label>
                            <Input
                                type="file"
                                onChange={(e) => setDocumentForm({...documentForm, file: e.target.files[0]})}
                                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                                required
                            />
                            {documentForm.file && (
                                <Alert color="info" className="mt-2">
                                    <strong>Archivo seleccionado:</strong> {documentForm.file.name} 
                                    ({formatFileSize(documentForm.file.size)})
                                </Alert>
                            )}
                            <small className="text-muted">
                                Formatos permitidos: PDF, Word, Excel, imágenes, texto (Max. 10MB)
                            </small>
                        </FormGroup>
                        
                        <div className="d-flex justify-content-end gap-2 mt-3">
                            <Button color="secondary" onClick={() => setModalOpen(false)} disabled={uploading}>
                                Cancelar
                            </Button>
                            <Button color="primary" type="submit" disabled={uploading || !documentForm.file}>
                                {uploading ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Creando...
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-save me-2"></i>
                                        Crear Documento
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            {/* Modal para ver detalles del documento */}
            <Modal isOpen={detailModal.open} toggle={() => setDetailModal({ open: false, document: null })} size="lg">
                <ModalHeader toggle={() => setDetailModal({ open: false, document: null })}>
                    📋 Detalles del Documento
                </ModalHeader>
                <ModalBody>
                    {detailModal.document && (
                        <div>
                            {/* Información básica */}
                            <Card className="mb-4">
                                <CardHeader className="bg-light text-dark">
                                    <h6 className="mb-0">📄 Información Básica</h6>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Código:</strong>
                                            <p>{detailModal.document.codigo || 'No asignado'}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Acta:</strong>
                                            <p>{detailModal.document.acta_number || 'No asignada'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Nombre del Documento:</strong>
                                            <p>{detailModal.document.name}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Tipo de Documento:</strong>
                                            <p>{detailModal.document.tipo_documento}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Área Solicitante:</strong>
                                            <p>{detailModal.document.area_solicitante}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Tipo de Solicitud:</strong>
                                            <p>
                                                <Badge color="info" className="text-capitalize">
                                                    {detailModal.document.request_type}
                                                </Badge>
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Versión:</strong>
                                            <p>v{detailModal.document.version}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Fecha de Solicitud:</strong>
                                            <p>{formatDate(detailModal.document.creation_date)}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <strong>Descripción del documento:</strong>
                                            <p>{detailModal.document.description}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <strong>Descripción de la solicitud:</strong>
                                            <p>{detailModal.document.observacion_solicitud}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Estado:</strong>
                                            <p>{getStatusBadge(detailModal.document.status)}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Tamaño del Archivo:</strong>
                                            <p>{formatFileSize(detailModal.document.file_size)}</p>
                                        </Col>
                                    </Row>
                                    {detailModal.document.rejection_observation && (
                                        <Row>
                                            <Col md={12}>
                                                <strong>Observación de Rechazo:</strong>
                                                <p className="text-danger">{detailModal.document.rejection_observation}</p>
                                            </Col>
                                        </Row>
                                    )}
                                </CardBody>
                            </Card>

                            {/* Repercusión en otros documentos */}
                            <Card className="mb-4">
                                <CardHeader className="bg-light text-dark">
                                    <h6 className="mb-0">📋 Repercusión del Cambio en Otros Documentos</h6>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(1)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_1)}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(2)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_2)}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(3)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_3)}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(4)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_4)}
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Información del usuario */}
                            <Card className="mb-4">
                                <CardHeader className="bg-light text-dark">
                                    <h6 className="mb-0">👤 Información del Usuario</h6>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Creado por:</strong>
                                            <p>{detailModal.document.user?.nombre || 'Usuario no disponible'}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Fecha de creación:</strong>
                                            <p>{formatDate(detailModal.document.created_at)}</p>
                                        </Col>
                                    </Row>
                                    {detailModal.document.approver && (
                                        <Row>
                                            <Col md={6}>
                                                <strong>Aprobado por:</strong>
                                                <p>{detailModal.document.approver?.nombre}</p>
                                            </Col>
                                            <Col md={6}>
                                                <strong>Fecha de aprobación:</strong>
                                                <p>{formatDate(detailModal.document.approval_date)}</p>
                                            </Col>
                                        </Row>
                                    )}
                                </CardBody>
                            </Card>

                            {/* Botones de acción */}
                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <Button 
                                    color="primary" 
                                    onClick={() => downloadDocument(detailModal.document)}
                                    disabled={!canDownloadDocument(detailModal.document)}
                                >
                                    <i className="fas fa-download me-2"></i>
                                    Descargar
                                </Button>
                                <Button 
                                    color="secondary" 
                                    onClick={() => setDetailModal({ open: false, document: null })}
                                >
                                    Cerrar
                                </Button>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Modal para aprobar/rechazar */}
            <Modal isOpen={statusModal.open} toggle={() => setStatusModal({ 
                open: false, 
                document: null, 
                action: '',
                acta_number: '',
                observation: ''
            })}>
                <ModalHeader toggle={() => setStatusModal({ 
                    open: false, 
                    document: null, 
                    action: '',
                    acta_number: '',
                    observation: ''
                })}>
                    {statusModal.action === 'aprobado' ? '✅ Aprobar Documento' : '❌ Rechazar Documento'}
                </ModalHeader>
                <ModalBody>
                    {statusModal.document && (
                        <div>
                            <div className="alert alert-info">
                                <strong>Documento:</strong> {statusModal.document.name}
                                <br />
                                <strong>Solicitante:</strong> {statusModal.document.user?.nombre || 'Usuario no disponible'}
                                <br />
                                <strong>Tipo:</strong> {statusModal.document.tipo_documento} - {statusModal.document.request_type}
                            </div>

                            {statusModal.action === 'aprobado' ? (
                                <>
                                    <FormGroup>
                                        <Label for="acta_number">
                                            <strong>Número de Acta *</strong>
                                        </Label>
                                        <Input
                                            type="text"
                                            id="acta_number"
                                            placeholder="Ingresa el número de acta de aprobación..."
                                            value={statusModal.acta_number}
                                            onChange={(e) => setStatusModal(prev => ({ 
                                                ...prev, 
                                                acta_number: e.target.value 
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="acta_codigo">
                                            <strong>Código Documento *</strong>
                                        </Label>
                                        <Input
                                            type="text"
                                            id="acta_codigo"
                                            placeholder="Ingresa el código del documento"
                                            value={statusModal.acta_codigo}
                                            onChange={(e) => setStatusModal(prev => ({ 
                                                ...prev, 
                                                acta_codigo: e.target.value 
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="acta_version">
                                            <strong>Versión Documento *</strong>
                                        </Label>
                                        <Input
                                            type="text"
                                            id="acta_version"
                                            placeholder="Ingresa el número de versión"
                                            value={statusModal.acta_version}
                                            onChange={(e) => setStatusModal(prev => ({ 
                                                ...prev, 
                                                acta_version: e.target.value 
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="acta_fecha_apro">
                                            <strong>Fecha de Vigencia *</strong>
                                        </Label>
                                        <Input
                                            type="date"
                                            id="acta_fecha_apro"
                                            value={statusModal.acta_fecha_apro}
                                            onChange={(e) => setStatusModal(prev => ({ 
                                                ...prev, 
                                                acta_fecha_apro: e.target.value 
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                </>
                            ) : (
                                <FormGroup>
                                    <Label for="observation">
                                        <strong>Observación de Rechazo *</strong>
                                    </Label>
                                    <Input
                                        type="textarea"
                                        id="observation"
                                        placeholder="Ingresa la razón del rechazo..."
                                        value={statusModal.observation}
                                        onChange={(e) => setStatusModal(prev => ({ 
                                            ...prev, 
                                            observation: e.target.value 
                                        }))}
                                        rows="3"
                                        required
                                    />
                                    <small className="text-muted">
                                        Esta observación será visible para el usuario solicitante.
                                    </small>
                                </FormGroup>
                            )}

                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <Button 
                                    color="secondary" 
                                    onClick={() => setStatusModal({ 
                                        open: false, 
                                        document: null, 
                                        action: '',
                                        acta_number: '',
                                        observation: ''
                                    })}
                                >
                                    Cancelar
                                </Button>
                                <Button 
                                    color={statusModal.action === 'aprobado' ? 'success' : 'danger'}
                                    onClick={handleStatusSubmit}
                                    disabled={
                                        statusModal.action === 'aprobado' 
                                            ? !statusModal.acta_number.trim() || !statusModal.acta_codigo.trim() || !statusModal.acta_version.trim() || !statusModal.acta_fecha_apro
                                            : !statusModal.observation.trim()
                                    }
                                >
                                    {statusModal.action === 'aprobado' ? '✅ Aprobar' : '❌ Rechazar'}
                                </Button>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Modal para visualizar documento */}
            <Modal isOpen={viewerModal.open} toggle={() => setViewerModal({ open: false, document: null })} size="xl">
                <ModalHeader toggle={() => setViewerModal({ open: false, document: null })}>
                    <div>
                        <div>Visualizar Documento: {viewerModal.document?.name}</div>
                        <small className="text-muted">
                            Carpeta: {folder.name}
                        </small>
                    </div>
                    <Button 
                        color="primary" 
                        size="sm" 
                        className="ms-2"
                        onClick={() => downloadDocument(viewerModal.document)}
                    >
                        <i className="fas fa-download me-1"></i>
                        Descargar
                    </Button>
                </ModalHeader>
                <ModalBody style={{ height: '80vh', padding: '0' }}>
                    {viewerModal.document && (
                        <div style={{ height: '100%', width: '100%' }}>
                            {viewerModal.document.file_type?.includes('pdf') ? (
                                <iframe 
                                    src={viewerModal.document.file_url}
                                    style={{ width: '100%', height: '100%', border: 'none' }}
                                    title={viewerModal.document.name}
                                />
                            ) : viewerModal.document.file_type?.includes('image') ? (
                                <div className="text-center p-3">
                                    <img 
                                        src={viewerModal.document.file_url}
                                        alt={viewerModal.document.name}
                                        style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                                    />
                                </div>
                            ) : viewerModal.document.file_type?.includes('text') || viewerModal.document.file_type?.includes('txt') ? (
                                <iframe 
                                    src={viewerModal.document.file_url}
                                    style={{ width: '100%', height: '100%', border: 'none' }}
                                    title={viewerModal.document.name}
                                />
                            ) : (
                                <div className="text-center py-4">
                                    <div className="fs-1 text-muted mb-3">📄</div>
                                    <h5>Vista previa no disponible</h5>
                                    <p>Este tipo de archivo no se puede visualizar en el navegador.</p>
                                    <Button 
                                        color="primary"
                                        onClick={() => downloadDocument(viewerModal.document)}
                                    >
                                        <i className="fas fa-download me-2"></i>
                                        Descargar Documento
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </div>
    );
};

export default DocumentFolderContent;